import { THEMES } from "../constants";
import getCookie from "./getCookie";
import { DARK_THEME, LIGHT_THEME } from "../themes";

export default function getThemeInitialState() {
  const theme = getCookie("theme");
  if (theme === THEMES.DARK) return DARK_THEME;
  return LIGHT_THEME;
}
